
import React, { lazy, Suspense } from "react";
import { Route } from "react-router-dom";

const LifestylePage = lazy(() => import("@/pages/calculators/LifestylePage"));
const AgeCalculatorPage = lazy(() => import("@/pages/calculators/lifestyle/AgeCalculatorPage"));
const DateCalculatorPage = lazy(() => import("@/pages/calculators/lifestyle/DateCalculatorPage"));
const TimeBetweenDatesCalculatorPage = lazy(() => import("@/pages/calculators/lifestyle/TimeBetweenDatesCalculatorPage"));
const LifeExpectancyCalculatorPage = lazy(() => import("@/pages/calculators/lifestyle/LifeExpectancyCalculatorPage"));
const CompatibilityCalculatorPage = lazy(() => import("@/pages/calculators/lifestyle/CompatibilityCalculatorPage"));
const LuckyNumberGeneratorPage = lazy(() => import("@/pages/calculators/lifestyle/LuckyNumberGeneratorPage"));
const WhichCharacterCalculatorPage = lazy(() => import("@/pages/calculators/lifestyle/WhichCharacterCalculatorPage"));
const PsychologicalCalculatorPage = lazy(() => import("@/pages/calculators/lifestyle/PsychologicalCalculatorPage"));
const TravelBudgetCalculatorPage = lazy(() => import("@/pages/calculators/lifestyle/TravelBudgetCalculatorPage"));
const GiftBudgetCalculatorPage = lazy(() => import("@/pages/calculators/lifestyle/GiftBudgetCalculatorPage"));
const PetFoodCalculatorPage = lazy(() => import("@/pages/calculators/lifestyle/PetFoodCalculatorPage"));

const Lazy = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<div className="flex items-center justify-center min-h-[50vh]"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" /></div>}>
    {children}
  </Suspense>
);

const LifestyleRoutes = [
  <Route path="/calculators/lifestyle" element={<Lazy><LifestylePage /></Lazy>} key="lifestyle" />,
  <Route path="/calculators/lifestyle/age" element={<Lazy><AgeCalculatorPage /></Lazy>} key="age" />,
  <Route path="/calculators/lifestyle/date" element={<Lazy><DateCalculatorPage /></Lazy>} key="date" />,
  <Route path="/calculators/lifestyle/time-between" element={<Lazy><TimeBetweenDatesCalculatorPage /></Lazy>} key="time-between" />,
  <Route path="/calculators/lifestyle/life-expectancy" element={<Lazy><LifeExpectancyCalculatorPage /></Lazy>} key="life-expectancy" />,
  <Route path="/calculators/lifestyle/compatibility" element={<Lazy><CompatibilityCalculatorPage /></Lazy>} key="compatibility" />,
  <Route path="/calculators/lifestyle/lucky-number" element={<Lazy><LuckyNumberGeneratorPage /></Lazy>} key="lucky-number" />,
  <Route path="/calculators/lifestyle/character-quiz" element={<Lazy><WhichCharacterCalculatorPage /></Lazy>} key="character-quiz" />,
  <Route path="/calculators/lifestyle/psychological" element={<Lazy><PsychologicalCalculatorPage /></Lazy>} key="psychological" />,
  <Route path="/calculators/lifestyle/travel-budget" element={<Lazy><TravelBudgetCalculatorPage /></Lazy>} key="travel-budget" />,
  <Route path="/calculators/lifestyle/gift-budget" element={<Lazy><GiftBudgetCalculatorPage /></Lazy>} key="gift-budget" />,
  <Route path="/calculators/lifestyle/pet-food" element={<Lazy><PetFoodCalculatorPage /></Lazy>} key="pet-food" />,
];

export default LifestyleRoutes;
